export interface SpeechOptions {
  rate?: number;
  pitch?: number;
  volume?: number;
  locale?: string;
}

export type ChimeType = 'success' | 'tap' | 'water' | 'celebrate';

export interface SpeechAudioProvider {
  speak(text: string, options?: SpeechOptions): Promise<void>;
  speakSyllablesAndWord(syllables: string[], word: string): Promise<void>;
  playChime(type?: ChimeType): void;
  stop(): Promise<void>;
}

export function shouldFallbackToOfflineSpeech(audioSucceeded: boolean): boolean {
  return !audioSucceeded;
}
